// extracted by mini-css-extract-plugin
export default {"root":"style_root__xtCfb","text":"style_text__Rf+Vl","link":"style_link__oBya0","button":"style_button__PPEzG"};